import _ from 'underscore';
import ComponentBase from 'components/_base/ComponentBase';
// import Utils from 'helpers/Utils';
// import jQuery from 'jquery';
import Components from '../index';

export default ComponentBase.extend(
  /**
   * @lends core.components.MainMenu
   */
  {
    constructor(options) {
      this.classPrefix  = `.${this.componentClass}-`;
      ComponentBase.prototype.constructor.call(this, options);
    },
    initialize(options) {
      ComponentBase.prototype.initialize.call(this, options);
      this.createConfigSubcomponents();
      this._createSubcomponents(this.components);
    },
    _createSubcomponents(components) {
      let availableComponents = _.filter(components, (component, key) => {
        if (component) {
          component.identifier = key;
          return true;
        } else {
          return false;
        }
      });

      let sortedComponens = _.sortBy(availableComponents, 'order');
      _.each(sortedComponens, (component) => {
        if (_.isObject(Components[component.componentConstructorClass])) {
          let _component = this.components[component.identifier] = new Components[component.componentConstructorClass]
            (
              _.extend({}, component, {
                map: this.map,
                widget: this.widget,
                isChild: true,
                properties: component.properties || {}
              }));
          this.append(_component.el, _component.position);
        }
      });
    },
    append(element, container) {
      this.$el.find(this.classPrefix + container).append(element);
    },

    addListeners() { }
  });



// WEBPACK FOOTER //
// ./src/components/mainMenuBlock/MainMenuBlock.js